





































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Md5 } from 'md5-typescript';
import HelpIcon from 'vue-material-design-icons/Help.vue';
import moment from 'moment';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { IRawDailyDataSumParam } from '../interfaces';
import { EnergyDisplay } from '../interfaces';

// you need to ts-ignore this line or TS will complain about the lack of type definitions
// there could be a more elegant solution though
// @ts-ignore
import InternalBarChart from '@/components/InternalBarChart.js';

@Component({
    components: { InternalBarChart },
})
export default class YearlyElectricity extends Vue {
    private dialog: boolean = false;
    private notifications: boolean = false;
    private sound: boolean = true;
    private widgets: boolean = false;

    private loaded: boolean = false;

    private chartWidth: number = 300;
    private chartHeight: number = 300;
    private startDate: moment.Moment = moment().startOf('week');
    private endDate: moment.Moment = moment().endOf('week');

    public async mounted() {
        this.refreshData();
    }

    public async refreshData() {
        // do an API call here and touch properties that will cause chartData() and chartOptions() to be called
        // Because of the reactiveProp mixin inside InternalChart.js, the chart will update automagically :)
    }

    public chartData(): object {
        // chart js DATA object. See https://www.chartjs.org/docs/latest/getting-started/usage.html
        return {
            labels: [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec',
            ],
            datasets: [
                {
                    label: 'Import',
                    type: 'bar',
                    data: [12, 19, 18, 17, 16, 10, 9, 9, 10, 11, 13, 11],
                    backgroundColor: 'rgba(0,0,0,0.2)',
                },
                {
                    label: 'Export',
                    type: 'bar',
                    data: [3, 3, 4, 8, 7, 8, 7, 6, 4, 5, 3, 2],
                    backgroundColor: 'rgba(0,0,0,0.2)',
                },
                {
                    type: 'line',
                    label: 'Solar Generated',
                    fill: false,
                    borderColor: '#ffd209',
                    data: [2, 1, 3, 6, 4, 3, 5, 4, 2, 3, 2, 1],
                },
            ],
        };
    }

    public chartOptions(): object {
        // chart js OPTIONS object. See https://www.chartjs.org/docs/latest/getting-started/usage.html
        return {
            title: {
                display: true,
                responsive: true,
                maintainAspectRatio: false,
                text: 'Yearly Solar Data House',
            },
            legend: { display: true },
        };
    }
}
